import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
  useFormHandler,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { useNavigate } from "react-router-dom";
import { usePagination } from "../../../../../hooks";
import { fetchAllSubmissions, updateSubmissionStatus } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../../utils/stringUtils";

const Shortlisted = ({ submissions,refreshCounts }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const { value } = useSelector((state) => state?.totalCount);
  const [shortlistedRows, setShortlistedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => state.auth);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {}
  );
  const totalCount = value?.jobShortlisted?.data || 0;
  const submissionIds = (submissions || [])
    .map((sub) => (typeof sub === "object" ? sub?.uiid : sub))
    .filter(Boolean);
  const colShortlisted = [
    {
      key: "sNo",
      label: "S.No",
    },
    {
      key: "name",
      label: "Name",
      render: (row) => <div className="text-info">{formatWords2(row?.name)}</div>,
    },
    {
      key: "email",
      label: "Email ID",
    },
    {
      key: "phone",
      label: "Phone number",
    },
    {
      key: "jobTitle",
      label: "Job Title",
    },
    {
      key: "experience",
      label: "Experience (In years)",
    },
    {
      key: "workAuthorization",
      label: "Work Authorization",
    },
    {
      key: "location",
      label: "Location",
    },
  ];

  const handleSelectionChange = (selectedRow) => {
    setSelectedRows(selectedRow);
  };
  // const mappedRowShortlisted = mapTableRows(rowShortlisted, colShortlisted);
  const intitialFormData = {
    emailSource: "",
    emailAccount: "",
    datePicker: "",
    template: "",
    subject: "",
    emailText: "",
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    intitialFormData,
    {
      emailSource: { type: "select", required: true },
    }
  );
  const handleModalOpen = (title) => {
    setIsModalOpen(true);
    setModalTitle(title);
  };

  const handlePipelineClick = async () => {
    if (selectedRows.length === 0) {
      navigate("/ats/jobs/job-details?job-details=pipeline");
      return;
    }

    try {
      setLoading(true);

      for (const row of selectedRows) {
        const payload = [
          {
            type: "PUSH",
            value: {
              statusHistory: {
                addedBy: user?.data?.uiid,
                addedOn: new Date().toISOString(),
                status: 2, // Pipeline status
              },
            },
          },
        ];

        await updateSubmissionStatus({
          coll: "Submission",
          uiid: row,
          payload,
        });
      }

      showToast("Updated to Pipeline successfully", "success");
      if (typeof refreshCounts === "function") {
        refreshCounts();
      }
      navigate("/ats/jobs/job-details?job-details=pipeline");
    } catch (err) {
      console.error(err);
      showToast("Failed to update pipeline status", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchSubmissions = async () => {
    // if (!submissions?.length) return;
    try {
      setLoading(true);
      const res = await fetchAllSubmissions({
        coll: "Submission",
        pg: page,
        lim: limit,
        ref: "JobPosting Candidate",
        fil: {
          uiid: { type: "IN", value: submissionIds },
          "statusHistory.status": {
            type: "ARRAY_LAST_TWO_FIELDS_EQ",
            value: 1,
          },
        },
        // fil: { uiid: { type: "IN", value: submissions },"statusHistory.status": {  type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 1 }  },
        ret: "uiid candidateId jobPostId",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location",
          "uiid firstName lastName email mobile salaryInfo.payRate jobTitle exp workAuth location",
        ],
        sort: { addedOn: -1 },
      });

      const data = res?.data?.data || [];
      const formattedRows = data.map((item, index) => ({
        id: item.uiid,
        sNo: index + 1,
        name: `${item?.candidateId?.firstName || ""} ${
          item?.candidateId?.lastName || ""
        }`.trim(),
        // email: item?.candidateId?.email?.primary || item?.candidateId?.email || "N/A",
        email:
          typeof item?.candidateId?.email === "string"
            ? item?.candidateId?.email
            : item?.candidateId?.email?.primary?.email || "N/A",
        phone: item.candidateId?.mobile?.primary?.number
          ? `${item.candidateId?.mobile.primary.code} ${item.candidateId.mobile.primary.number}`
          : "N/A",
        jobTitle: formatWords2(item?.candidateId?.jobTitle || "N/A"),
        experience: item?.candidateId?.exp
          ? `${item?.candidateId?.exp.year || 0}y ${
              item?.candidateId?.exp.mon || 0
            }m`
          : "N/A",
        workAuthorization:
         item?.candidateId?.workAuth ? formatWords2(item?.candidateId?.workAuth) : "N/A",
        location: item?.candidateId?.location
          ? `${item?.candidateId?.location.city || ""}, ${
              item?.candidateId?.location.state || ""
            }`
          : "N/A",
      }));

      setShortlistedRows(mapTableRows(formattedRows, colShortlisted));
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "jobShortlisted",
        app: "ats",
        filters: {
          uiid: { type: "IN", value: submissionIds },
          "statusHistory.status": {
            type: "ARRAY_LAST_TWO_FIELDS_EQ",
            value: 1,
          },
        },
      })
    );
    fetchSubmissions();
  }, [submissions, limit, page]);
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LogoLoader />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex-1 overflow-hidden shadow-tableset">
          <TableAdv
            showCheckbox
            columns={colShortlisted}
            // rows={mappedRowShortlisted}
            rows={shortlistedRows}
            onSelectionChange={handleSelectionChange}
            serverPagination={true}
            totalCount={totalCount}
            defaultSelectedRows={selectedRows}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            tdClassName="!py-3"
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-2">
                      {selectedRows.length <= 1 ? (
                        <Button
                          title="Send Mail"
                          size="sm"
                          onClick={() => handleModalOpen("Send Mail")}
                        />
                      ) : (
                        <Button
                          title="Bulk Mail"
                          size="sm"
                          onClick={() => handleModalOpen("Bulk Mail")}
                        />
                      )}

                      <Button
                        title="Pipeline"
                        size="sm"
                        onClick={() =>
                          // navigate("/ats/jobs/job-details?job-details=pipeline")
                          handlePipelineClick()
                        }
                      />
                    </div>
                  ),
                },
              ],
            }}
          />
        </div>
      </div>
      <Modal isOpen={isModalOpen} showCloseButton={false} width="max-w-6xl">
        <div>
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={modalTitle}
            className="!px-0 font-[500]"
            size="xl"
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-5">
          <FormFieldSet
            type="select"
            title="Email Source"
            placeholder="Select"
            options={[
              { label: "Gmail", value: 1 },
              { label: "Outlook", value: 2 },
              { label: "Mailgun", value: 3 },
              { label: "AWS-SES", value: 4 },
            ]}
            value={formData.emailSource}
            onChange={(value) => handleChange("emailSource", value)}
            error={errors.emailSource}
          />
          <FormFieldSet
            type="select"
            title="Email Account"
            placeholder="Select Account"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            value={formData.emailAccount}
            onChange={(value) => handleChange("emailAccount", value)}
            error={errors.emailAccount}
          />
          <FormFieldSet
            type="datepicker"
            title="Date Picker"
            placeholder="Select Date"
            value={formData.datePicker}
            onChange={(value) => handleChange("datePicker", value)}
            error={errors.datePicker}
          />
          <FormFieldSet
            type="select"
            title="Template"
            placeholder="Select"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            value={formData.template}
            onChange={(value) => handleChange("template", value)}
            error={errors.template}
          />
          <FormFieldSet
            title="Subject"
            placeholder="Select"
            value={formData.subject}
            onChange={(value) => handleChange("subject", value)}
            error={errors.subject}
          />
        </div>
        <div className="flex flex-col my-4 gap-4">
          <FormFieldSet
            value={["simon@tektreeinc.com", "john.doe@tektreeinc.com"]}
            maxCount={50}
            type="toMailIds"
            title="Include Test Emails Here: 2"
          />
          <FormFieldSet
            type="textArea"
            title="Text Here"
            rows={5}
            placeholder="Enter Text Here"
            value={formData.emailText}
            onChange={(value) => handleChange("emailText", value)}
            error={errors.emailText}
          />
        </div>
        <div className="flex justify-end gap-5 my-10">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => setIsModalOpen(false)}
          />
          <Button title={"Send Email"} />
        </div>
      </Modal>
    </div>
  );
};

export default Shortlisted;
